import { useCallback, useMemo } from 'react'
import { useConfig } from '../../context/Config'
import { useFetch } from '../../hooks/useFetch'
import { meDecoder } from './me'

export const useSelf = () => {
  const { baseUrl } = useConfig()
  const fetch = useFetch()

  const fetchMe = useCallback(
    () =>
      fetch({
        auth: true,
        decoder: meDecoder,
        endpoint: `${baseUrl}/users/self`,
        method: 'GET',
      }),
    [baseUrl, fetch]
  )

  return useMemo(() => ({ fetchMe }), [fetchMe])
}
